export const SocialAssetDataType = {
  SaleReview: 'SaleReview',
  LeasingReview: 'LeasingReview',
  MortgageBrokingReview: 'MortgageBrokingReview',
  ExternalReview: 'ExternalReview',
  SalesNewListing: 'SalesNewListing',
  LeasingNewListing: 'LeasingNewListing',
  SalesSoldListing: 'SalesSoldListing',
  LeasingLeasedListing: 'LeasingLeasedListing',
  Awards: 'Awards',
} as const;

export type SocialAssetDataType = (typeof SocialAssetDataType)[keyof typeof SocialAssetDataType];
